import { createContext, useCallback, useContext, useRef, useState } from "react";

const UploadStatusContext = createContext({ isUploading: false, begin: () => {}, end: () => {} });

/**
 * Tracks how many uploads are in flight anywhere on the page. ImageUpload
 * (and anything else that uploads a file) registers itself here so that
 * Save buttons can disable themselves while an upload is still pending —
 * otherwise clicking Save before an upload finishes silently saves the
 * old value instead of the newly-uploaded one.
 */
export function UploadStatusProvider({ children }) {
    const countRef = useRef(0);
    const [isUploading, setIsUploading] = useState(false);

    const begin = useCallback(() => {
        countRef.current += 1;
        setIsUploading(true);
    }, []);

    const end = useCallback(() => {
        countRef.current = Math.max(0, countRef.current - 1);
        setIsUploading(countRef.current > 0);
    }, []);

    return (
        <UploadStatusContext.Provider value={{ isUploading, begin, end }}>
            {children}
        </UploadStatusContext.Provider>
    );
}

export function useUploadStatus() {
    return useContext(UploadStatusContext);
}
